import * as React from "react";

import {isApiTrue}      from "@Common/logic/is-api-true";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {BRANCH_LEVEL, COMPANY_LEVEL} from "../../../../common/logic/user-level";

import {DnmModal} from "./dnm-modal";

export const DoNotMailSection = ({next}) => cs(
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ["modal", ({}, next) => DnmModal({next})],
    ({company, session, modal, userLevels}) => next({
        isLoading : false,
        render    : () => (
            userLevels.userLevel === BRANCH_LEVEL ? (
                session.data.branch && (isApiTrue(company.prefs.branchDnm) || 
                    isApiTrue(session.data.branch.prefs.enableOfficeDnmList) || 
                    (session.data.branch.prefs.enableOfficeDnmList == 2 && isApiTrue(company.prefs.enableOfficeDnmList))) 
                    && <div key="dnm" className="section">
                        <div className="header">
                            <div className="title" xd-qa-type="label" xd-qa-name="Do Not Mail List">Do Not Mail List</div>
                            {(session.data.branch && showCompanyAndOfficeDoNotMailList({company, branch: session.data.branch})) ? (<>
                                <div onClick={modal.show} xd-qa-type="link" xd-qa-name="Manage Company Do Not Mail List" className="edit">Company</div>
                                <div onClick={() => modal.show({officeId: session.value.branchId})} xd-qa-type="link" xd-qa-name="Manage Office Do Not Mail List" className="edit">Office</div>
                            </>) : (
                                <div onClick={userLevels.userLevel === COMPANY_LEVEL || (company && company.prefs.branchDnm) ? (
                                    modal.show
                                ) : (
                                    () => modal.show({officeId: session.value.branchId}))
                                } 
                                xd-qa-type="link"
                                xd-qa-name="Manage Do Not Mail List"
                                className="edit">
                                    Add/Remove
                                </div>
                            )}
                        </div>
                    </div>
            ) : (
                <div key="dnm" className="section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Do Not Mail List">Do Not Mail List</div>
                        <div onClick={modal.show} 
                            xd-qa-type="link"
                            xd-qa-name="Manage Do Not Mail List"
                            className="edit">
                                Add/Remove
                        </div>
                    </div>
                </div>
            )
        ),
    }),
);

const showCompanyAndOfficeDoNotMailList = ({company, branch}) => {
    return company && isApiTrue(company.prefs.branchDnm) && branch.prefs.enableOfficeDnmList ? (
        branch.prefs.enableOfficeDnmList != 0 && company.prefs.enableOfficeDnmList == 1
    ) : (
        company && isApiTrue(company.prefs.branchDnm) && isApiTrue(company.prefs.enableOfficeDnmList)
    )
}
